import React from 'react';
import { Card, Col, Container, Row, FormGroup, Label, Input } from 'reactstrap';
import { inject } from 'mobx-react';
import { Button } from '../../../elements';
import { ButtonsBar } from '../../../Styles';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from '../../../Theme';
import { t, T } from '../../../helpers/i18n';
import { loading } from '../../../elements/Loading';
import { useCollaboratorForm } from '../../../hooks/useCollaboratorForm';
import history from '../../../helpers/History';
import CommmissionCollaborator from './CommissionCollaborator';
import CollaboratorStretchSelect from './CollaboratorStretchSelect';
var CollaboratorsFormEdit = function (_a) {
    var store = _a.store, match = _a.match, collaborator = _a.collaborator, _b = _a.stretches, stretches = _b === void 0 ? [] : _b, _c = _a.packets, packets = _c === void 0 ? [] : _c;
    var hasParent = (history.location.pathname.match(/\//g) || []).length >= 2;
    var canBeDisabled = 'disabled' in (collaborator || {}) || 'disabled_at' in (collaborator || {});
    var disabled = canBeDisabled && ((collaborator === null || collaborator === void 0 ? void 0 : collaborator.disabled_at) != null);
    var _d = useCollaboratorForm(collaborator, store, match.params.id), handleSubmit = _d.handleSubmit, handleCancel = _d.handleCancel, selectedStretches = _d.selectedStretches, handleChange = _d.handleChange;
    if (!collaborator)
        return React.createElement("div", null, "No encontrado");
    return (React.createElement("div", null,
        React.createElement(Card, { className: "m-3 p-3" },
            React.createElement(Container, null,
                React.createElement(Row, { className: "align-items-center" },
                    React.createElement(Col, { xl: 4, md: 6, sm: 12 },
                        React.createElement(FormGroup, null,
                            React.createElement(Label, { for: "name" }, T('businessunit')),
                            React.createElement(Input, { value: collaborator.name, type: "email", id: "businessName", disabled: true }))),
                    React.createElement(Col, { xl: 4, md: 6, sm: 12 },
                        React.createElement(FormGroup, null,
                            React.createElement(Label, { for: "tinCollaborator" }, T('tin')),
                            React.createElement(Input, { value: collaborator.tin, id: "tinCollaborator", disabled: true }))),
                    React.createElement(Col, { xl: 4, md: 6, sm: 12 },
                        React.createElement(FormGroup, null,
                            React.createElement(Label, { for: "codeCollaborator" }, T('codeCollaborator')),
                            React.createElement(Input, { value: collaborator.codeCollaborator, id: "codeCollaborator", disabled: true })))))),
        React.createElement(CommmissionCollaborator, { collaborator: collaborator }),
        React.createElement(CollaboratorStretchSelect, { stretches: stretches, selectedStretches: selectedStretches, onChange: handleChange }),
        React.createElement(ButtonsBar, null,
            hasParent && (React.createElement(StyledButton, { onClick: handleCancel }, t('cancel'))),
            collaborator && canBeDisabled && (disabled ? (React.createElement(StyledButton, { isDisabled: true, onClick: function () { } }, t('enable'))) : (React.createElement(StyledButton, { onClick: function () { } }, t('disable')))),
            React.createElement(StyledButton, { primary: true, loading: false, onClick: handleSubmit }, t('save')))));
};
var StyledButton = cxs(Button)(function (_a) {
    var _b;
    var isDisabled = _a.isDisabled;
    return (_b = {
            color: isDisabled ? Theme.color.primary : 'inherit'
        },
        _b[mediaQueries.desktop] = {
            padding: Theme.size.space[2]
        },
        _b);
});
export default inject('store')(loading(function (props) { return [
    props.match.params.id ? props.store.collaboratorStore.read(props.match.params.id)
        .then(function (collaborator) { return ({ collaborator: collaborator }); }) : undefined,
    props.match.params.id ? props.store.stretches.read().then(function (stretches) { return ({ stretches: stretches }); }) : undefined,
    props.match.params.id ? props.store.packetStore.read().then(function (packets) { return ({ packets: packets }); }) : undefined
]; })(CollaboratorsFormEdit));



//////////////////
// WEBPACK FOOTER
// ./src/modules/Collaborators/container/CollaboratorsFormEdit.tsx
// module id = 1552
// module chunks = 0